import React from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Breadcrumb from '../../components/Breadcrumb';
import ContactMain from './ContactMain';
import ScrollToTop from '../../components/ScrollTop';
import FooterTwo from '../../components/Footer/FooterTwo';

// Image
import Logo from '../../assets/images/logos/logo2.png';
import SectionTitle from '../../components/SectionTitle';

const Contact = () => {
    return (
        <>
            <Header
                parentMenu='contact'
                menuCategoryEnable='enable'
                // headerNormalLogo={Logo}
                // headerStickyLogo={Logo}
                topbarEnable='enable'
            />

            <div class="react-wrapper">
                <div class="react-wrapper-inner">
                    <Breadcrumb pageTitle="Contact Us" />
                    <ContactMain />
                    <div className='mb-2'>
                    <SectionTitle Title="Our Deepest Humblest Gratitude" subtitle="To All Stakeholders"/>
                    </div>
                 
                    {/* scrolltop-start */}
                    <ScrollToTop />
                    {/* scrolltop-end */}
                </div>
            </div>

            {/* <Footer /> */}
            <FooterTwo/>

        </>
    );
}


export default Contact;

